import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router';
import { Provider, useAtom } from 'jotai/index';
import store from './atoms';
import { SidebarData } from './helpers/SidebarData';
import Wrapper from './components/Wrapper';
import { languageAtom } from './atoms/globalAtoms';
import LocalStorageServices from './services/LocalStorageServices';

function App() {
  const [, setLanguage] = useAtom(languageAtom);

  useEffect(() => {
    const params = window.location.href.split('?')[1];
    if (params === 'lang=en') {
      setLanguage('en');
      LocalStorageServices.setLanguage('en');
    } else if (params === 'lang=ru') {
      setLanguage('ru');
      LocalStorageServices.setLanguage('ru');
    }
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Wrapper>
          <Routes>
            {Object.values(SidebarData).map((item) => (
              <Route key={item.path} path={item.path} element={item.component} />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Wrapper>
      </Router>
    </Provider>
  );
}

export default App;
